import VwVezneKullanicimapDTO from 'src/models/Base/Yetki/VwVezneKullanicimapDTO';
import { ApiService } from 'src/services/core';

class VezneKullaniciMapService {
    private service: ApiService<VwVezneKullanicimapDTO>;
    constructor() {
        this.service = new ApiService<VwVezneKullanicimapDTO>("VwVezneKullanicimapDTO")
    }

    getVezneByKullanici = (userId: number) => {
        return this.service.find({
            filters: {
                groupOperator: 'and',
                predicates: [
                    { fieldName: 'fkGnlKullanici', operator: '=', value1: userId }
                ]
            },
        })
    }
    create = (data: VwVezneKullanicimapDTO) => {
        return this.service.create(data)
    }
    delete = (id: number) => {
        return this.service.delete(id)
    }
}
export default new VezneKullaniciMapService();